import { useState } from 'react';
import PDFGenerator from '../utils/PDFGenerator';

export const usePDFGenerator = () => {
  const [isGenerating, setIsGenerating] = useState(false);
  const [error, setError] = useState(null);

  const generateQuotePDF = async (quote, customer, vehicle, settings, action = 'download') => {
    setIsGenerating(true);
    setError(null);

    try {
      const generator = new PDFGenerator();
      const doc = await generator.generateQuotePDF(quote, customer, vehicle, settings);
      
      const filename = `Devis_${quote.quote_number}_${customer?.name?.replace(/\s+/g, '_') || 'Client'}.pdf`;
      
      if (action === 'download') {
        generator.download(filename);
      } else if (action === 'preview') {
        generator.preview();
      } else if (action === 'blob') {
        // Retourner le PDF comme blob pour le partage
        return generator.getBlob();
      }
      
      return doc;
    } catch (err) {
      console.error('Erreur génération PDF devis:', err);
      setError('Erreur lors de la génération du PDF du devis');
      throw err;
    } finally {
      setIsGenerating(false);
    }
  };

  const generateInvoicePDF = async (invoice, customer, vehicle, settings, action = 'download') => {
    setIsGenerating(true);
    setError(null);

    try {
      const generator = new PDFGenerator();
      const doc = await generator.generateInvoicePDF(invoice, customer, vehicle, settings);
      
      const filename = `Facture_${invoice.invoice_number}_${customer?.name?.replace(/\s+/g, '_') || 'Client'}.pdf`;
      
      if (action === 'download') {
        generator.download(filename);
      } else if (action === 'preview') {
        generator.preview();
      } else if (action === 'blob') {
        // Retourner le PDF comme blob pour le partage
        return generator.getBlob();
      }
      
      return doc;
    } catch (err) {
      console.error('Erreur génération PDF facture:', err);
      setError('Erreur lors de la génération du PDF de la facture');
      throw err;
    } finally {
      setIsGenerating(false);
    }
  };

  return {
    generateQuotePDF,
    generateInvoicePDF,
    isGenerating,
    error
  };
};
